import { ActionType, createReducer } from 'typesafe-actions'
import { resetCampaignDataAction } from '@/redux/company/handles/resetCampaignDataAction'
import {
  createQuickReplyHandle,
  deleteQuickReplyHandle,
  fetchRepliesByCompanyHandle,
  updateQuickReplyHandle
} from './handles'
import { QuickReplyState, QuickReplyAction } from './types'

type Action = QuickReplyAction | ActionType<typeof resetCampaignDataAction>

export const initialState: QuickReplyState = {
  isErrorOnCreateQuickReply: false,
  isLoadingCreateQuickReply: false,
  isSuccessOnCreateQuickReply: false,
  isErrorOnUpdateQuickReply: false,
  isLoadingUpdateQuickReply: false,
  isSuccessOnUpdateQuickReply: false,
  isErrorOnDeleteQuickReply: false,
  isLoadingDeleteQuickReply: false,
  isSuccessOnDeleteQuickReply: false,
  replies: [],
  isLoadingFetchRepliesByCompany: false,
  isSuccessOnFetchRepliesByCompany: false,
  isErrorOnFetchRepliesByCompany: false
}

export const quickReplyReducer = createReducer<QuickReplyState, Action>(initialState)
  .handleAction(createQuickReplyHandle.asyncAction.request, createQuickReplyHandle.request)
  .handleAction(createQuickReplyHandle.asyncAction.success, createQuickReplyHandle.success)
  .handleAction(createQuickReplyHandle.asyncAction.failure, createQuickReplyHandle.failure)
  .handleAction(updateQuickReplyHandle.asyncAction.request, updateQuickReplyHandle.request)
  .handleAction(updateQuickReplyHandle.asyncAction.success, updateQuickReplyHandle.success)
  .handleAction(updateQuickReplyHandle.asyncAction.failure, updateQuickReplyHandle.failure)
  .handleAction(deleteQuickReplyHandle.asyncAction.request, deleteQuickReplyHandle.request)
  .handleAction(deleteQuickReplyHandle.asyncAction.success, deleteQuickReplyHandle.success)
  .handleAction(deleteQuickReplyHandle.asyncAction.failure, deleteQuickReplyHandle.failure)
  .handleAction(fetchRepliesByCompanyHandle.asyncAction.request, fetchRepliesByCompanyHandle.request)
  .handleAction(fetchRepliesByCompanyHandle.asyncAction.success, fetchRepliesByCompanyHandle.success)
  .handleAction(fetchRepliesByCompanyHandle.asyncAction.failure, fetchRepliesByCompanyHandle.failure)
  .handleAction(resetCampaignDataAction, state => ({
    ...state,
    replies: []
  }))
